module.exports = __webpack_public_path__ + "static/media/about-bg-desktop.88978a4e.jpg";